module.exports = __webpack_public_path__ + "static/media/video-poster.749cb658.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/video-poster.png
// module id = 694
// module chunks = 0